import { IProdutoOutroSistemaForm } from '../../../../../../modules/types/ProdutoDaf';

export const defaultProdutoOutroSistemaFormMain: IProdutoOutroSistemaForm = {
  ////////////////////////////////////////
  // Identificador
  id: 0,

  ////////////////////////////////////////
  // Chaves estrangeiras
  usuarioId: 0,
  produtoDAFId: 0,

  ////////////////////////////////////////
  // Dados do vínculo com outro sistema
  outroSistema: 0,
  codigoProduto: '',
  nomeProduto: '',

  ////////////////////////////////////////
  // Observações
  observacoes: '',
};
